export default '/build/e40073ac.svg'